
/* Show the ".checkout-link__button" button in the site header and hide Checkout+ snippet */
document.addEventListener('DOMContentLoaded', () => {
  const siteHeader = document.querySelector('.header-tools-wrapper');
  if (!siteHeader) return;

  function hideCheckoutPlusInHeader() {
    const offsetWrapInHeader = document.querySelector('.checkout-link .offset-cart-offer-container');
    if (!offsetWrapInHeader) return;

    const headerCheckoutButton = document.querySelector('.checkout-link__button');

    if (headerCheckoutButton) {
      headerCheckoutButton.style.setProperty('display', 'block', 'important');
      offsetWrapInHeader.style.setProperty('display', 'none', 'important');
    }      
  }

  let updateFrameId = null;
  const schedule = () => {
    if (updateFrameId != null) return;
    updateFrameId = requestAnimationFrame(() => {
      updateFrameId = null;
      hideCheckoutPlusInHeader();
    });
  };

  const observer = new MutationObserver(schedule);
  observer.observe(siteHeader, { childList: true, subtree: true });

  hideCheckoutPlusInHeader();
});